import { BaseService } from './base.service';
import { ApartmentSearchFilterDTO } from '../model/ApartmentSearchFilterDTO';
import { FloorDTO } from '../model/FloorDTO';
import { ApartmentSearchStatsDTO } from '../model/ApartmentSearchStatsDTO';
import { ApartmentSearchSortType } from '@/enums/ApartmentSearchSortType';
import { ApartmentSearchDTO } from '../model/ApartmentSearchDTO';
import { ApartmentDTO } from '../model/ApartmentDTO';
import { ApartmentMicroDTO } from '../model/ApartmentMicroDTO';
import { HypoCalcInfoDTO } from '../model/HypoCalcInfoDTO';
import { ApartmentSearchSortDirection } from '../enums/ApartmentSearchSortDirection';

export class ApartmentService extends BaseService {
	async fetchApartment(catalogNumber: string, excludeFakeSold: boolean = true): Promise<ApartmentDTO> {
		return await this.fetch<ApartmentDTO>(`/api/apartment/${catalogNumber}`, {
			excludeFakeSold
		});
	}

	async fetchApartments(filter: ApartmentSearchFilterDTO, sort?: ApartmentSearchSortType, sortDirection?: ApartmentSearchSortDirection, limit?: number, offset?: number) {
		return await this.fetch<ApartmentSearchDTO[]>('/api/apartment/search', {
			...filter,
			sort: [sort],
			sortDirections: [sortDirection || ApartmentSearchSortDirection.Up],
			limit,
			offset
		});
	}

	async fetchSearchStats(filter: ApartmentSearchFilterDTO, limit?: number, offset?: number) {
		return await this.fetch<ApartmentSearchStatsDTO>('/api/apartment/search/stats', {
			...filter,
			limit,
			offset
		});
	}

	async fetchFloors(housingBlockId: number) {
		return await this.fetch<FloorDTO[]>('/api/apartment/floor', {
			housingBlockId
		});
	}

	async fetchHypoCalcInfo(totalPrice: number, completionDate: Date) {
		return await this.fetch<HypoCalcInfoDTO>('/api/apartment/hypo', {
			totalPrice,
			completionDate
		});
	}

	async fetchSimilarApartments(locationId: number, layoutRoomCount: number, catalogNumber: string) {
		return await this.fetch<ApartmentMicroDTO[]>('/api/apartment/similar', {
			locationId,
			layoutRoomCount,
			catalogNumber,
		});
	}

	async fetchFavoriteApartments(catalogNumbers: string): Promise<ApartmentMicroDTO[]> {
		return await this.fetch<ApartmentMicroDTO[]>('/api/apartment/favorite', {
			catalogNumbers
		});
	}

}
